module.exports = __webpack_public_path__ + "img/qrcode.f9af5938.png";